import { createContext, useContext } from 'react';

interface TemplateGalleryOptions {
  envelopeId?: string;
}

export interface TemplateGalleryContextType {
  showGallery: (options: TemplateGalleryOptions) => void;
  hideGallery: () => void;
  isShown: boolean;
  galleryOptions: TemplateGalleryOptions | null;
  showDeleteTemplateDialog: (params: {
    templateId: string;
    isInUse: boolean;
  }) => void;
}

export const TemplateGalleryContext =
  createContext<TemplateGalleryContextType>({
    showGallery: () => {},
    hideGallery: () => {},
    isShown: false,
    galleryOptions: null,
    showDeleteTemplateDialog: () => {},
  });

export const useTemplateGalleryContext = () => {
  const context = useContext(TemplateGalleryContext);

  if (!context) {
    throw new Error(
      'useTemplateGallery must be used within a TemplateGalleryProvider',
    );
  }

  return context;
};